/** Which of the record page's five tabs a `?tab=` value names.
 *
 * **The old keys still resolve**, so a link someone saved last week opens the tab that took over its
 * content: Review is Details, Original source is Document, Workflow is Approvals, and the Correct
 * tab became a button in the header (its explanation opens from there), so its key opens Details. An
 * unknown value opens Details, never an empty panel.
 */

import { RECORD_TABS } from "../components/ui";
import type { RecordTabKey } from "../components/ui";

const LEGACY: Readonly<Record<string, RecordTabKey>> = {
  review: "details",
  source: "document",
  correct: "details",
  workflow: "approvals",
};

export function recordTabOf(value: string | undefined): RecordTabKey {
  if (value === undefined) return "details";
  const direct = RECORD_TABS.find((tab) => tab.key === value);
  return direct ? direct.key : (LEGACY[value] ?? "details");
}
